/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
/**
 * Batch store implementation of the PickerStore.
 */
'use strict';

angular
  .module('stores.picker.batch', ['stores.picker'])
  .factory('BatchPickerStore', function (PickerStore, httpBatch, batchUtils, $filter, NG_DATE_FORMATS, $q) {
    /**
     * The BatchPickerStore.  It will create a picker store specific to a batch picker.
     * @constructor
     */
    var BatchPickerStore = function () {
      PickerStore.apply(this, arguments);
      this.nextTooltipText = $filter('i18n')('NEXT_BACKUP');
      this.previousTooltipText = $filter('i18n')('PREVIOUS_BACKUP');
      this.latestLabel = $filter('i18n')('LATEST_BACKUP');
      this.getDetails();
    };

    BatchPickerStore.prototype = new PickerStore();
    BatchPickerStore.prototype.name = 'BatchPickerStore';

    /**
     * Utility function used to get the batch details.
     *
     * @returns {Promise} - A promise that resolves after the details have been returned.
     */
    BatchPickerStore.prototype.getDetails = function () {
      var self = this;
      return httpBatch.getBackupDetails().then(function (details) {
        self.details = angular.copy(details);
      });
    };

    /**
     * Get the current id of the loaded batch.
     * @returns {Number} - The id.
     */
    BatchPickerStore.prototype.getCurrentId = function () {
      return batchUtils.currentBatch.batchId;
    };

    // Override all necessary functions from the PickerStore.
    /**
     * @overrides {@link PickerStore.getNext}
     */
    BatchPickerStore.prototype.getNext = function () {
      var currentId = this.getCurrentId();

      if (this.details && _.isNumber(currentId) && currentId !== this.details.backup.last.id) {
        return batchUtils.getNextBatch();
      } else {
        // Return a fake promise here, so we will hit then handler in picker.js and hide loading mask
        return $q.when();
      }
    };

    /**
     * @overrides {@link PickerStore.getPrevious}
     */
    BatchPickerStore.prototype.getPrevious = function () {
      var currentId = this.getCurrentId();

      if (this.details && _.isNumber(currentId) && currentId !== this.details.backup.first.id) {
        return batchUtils.getPreviousBatch();
      } else {
        // Return a fake promise here, so we will hit then handler in picker.js and hide loading mask
        return $q.when();
      }
    };

    /**
     * @overrides {@link PickerStore.getLatest}
     */
    BatchPickerStore.prototype.getLatest = function () {
      return batchUtils.getLatestBackup();
    };

    /**
     * @overrides {@link PickerStore.getByDate}
     */
    BatchPickerStore.prototype.getByDate = function (dateOfInterest) {
      return batchUtils.getBatchByDate(dateOfInterest);
    };

    /**
     * @overrides {@link PickerStore.getMin}
     */
    BatchPickerStore.prototype.getMin = function () {
      if (this.details) {
        return this.details.backup.first.timestamp;
      }
    };

    /**
     * @overrides {@link PickerStore.getMax}
     */
    BatchPickerStore.prototype.getMax = function () {
      if (this.details) {
        return this.details.backup.last.timestamp;
      }
    };

    /**
     * @overrides {@link PickerStore.previousDisabled}
     */
    BatchPickerStore.prototype.previousDisabled = function () {
      return (this.details && this.getCurrentId() === this.details.backup.first.id) || batchUtils.currentBatch.noBackup
        ? true
        : false;
    };

    /**
     * @overrides {@link PickerStore.nextDisabled}
     */
    BatchPickerStore.prototype.nextDisabled = function () {
      return (this.details && this.getCurrentId() === this.details.backup.last.id) || batchUtils.currentBatch.noBackup
        ? true
        : false;
    };

    /**
     * @overrides {@link PickerStore.setupDateTimeListener}
     */
    BatchPickerStore.prototype.setupDateTimeListener = function ($scope) {
      $scope.$watch(
        function () {
          return batchUtils.currentBatch;
        },
        function () {
          if (batchUtils.currentBatch.noBackup) {
            $scope.format = NG_DATE_FORMATS.SHORT;
          } else {
            $scope.dt = batchUtils.currentBatch.date;
            $scope.format = NG_DATE_FORMATS.LONG;
          }
        },
        true
      );
    };

    return BatchPickerStore;
  });
